import { createActions, createAction } from 'redux-actions';
export var getTheme = createActions('GET_THEME').getTheme;
export var getThemeComplete = createAction('GET_THEME_COMPLETE', function (payload) { return payload; }, function (payload, headers) { return ({ headers: headers }); });
